import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import deletePhaseRule from "api/campaign/deletePhaseRule";
import handleInvalidateError from "helpers/handleInvalidateError";
import { phaseRulesWithCampaignId } from "queryKeys/phaseRulesKey"; // Using the more specific key factory

export default function useDeletePhaseRuleMutation() {
  const queryClient = useQueryClient();
  const { id: campaignId } = useParams();

  return useMutation({
    mutationFn: deletePhaseRule,
    onSuccess: (data) => {
      toast.success(data?.message || "Rule deleted successfully!");

      queryClient
        .invalidateQueries({ queryKey: phaseRulesWithCampaignId({ campaignId }) })
        .catch(handleInvalidateError);
    },
    onError: (error) => {
      toast.error(error?.message || "Failed to delete rule.");
    },
  });
}
